const React = require("react");
const T = React.PropTypes;

const styles = {
    Outer: {
        display: "flex",
        flexFlow: "row wrap",
        width: "100%",
        maxWidth: 700,
        backgroundColor: "#e8e8e8",
        boxShadow: "0px 2px 3px #bbb"
    },
    FileBox: {
        flex: "1",
        padding: 10,
        borderRight: "1px solid #ddd"
    },
    DetailBox: {
        flex: "2",
        padding: 10
    }
};

const FileInfoBox = React.createClass({
    props: {
        FileNode: T.node.isRequired,
        InfoNode: T.node.isRequired,
        style: T.object
    },
    getDefaultProps(){
        return {
            style: {}
        };
    },
    render() {
        const style = Object.assign({}, styles.Outer, this.props.style);

        return (<div style={style}>
            <div style={styles.FileBox}>
                {this.props.FileNode}
            </div>
            <div style={styles.DetailBox}>
                {this.props.InfoNode}
            </div>
        </div>);
    }
});

module.exports = FileInfoBox;


// WEBPACK FOOTER //
// ./src/components/FileInfoBox.jsx